import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from '../../services/services';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { enc, SHA512 } from 'crypto-js';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { EncryptionService } from "src/app/services/encryption.service";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";
@Component({
    selector: 'nri-app-visa',
    templateUrl: './visa.component.html',
    styleUrls: ['./visa.component.scss']
  })
export class VisaComponent implements OnInit{
  arrivalDateError: boolean = false;
  docTypeList: any = '';
  docType: any = '';
  docError: boolean = false;
  erefNo: string = '';
  expiryDateError: boolean = false;
  lastArrivalDate: any = '';
  mariner: boolean = false;
  options: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  options2:INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  pdf1Imgempty: boolean = false;
  pdf1Updt: boolean = false;
  pdf2Imgempty: boolean = false;
  pdf2Updt: boolean = false;
  prevsixMonthDate:any;
  sixMonthDate:any;
  visaImgempty: boolean = false;
  visaUpdt: boolean = false;
  visaExpiryError: boolean = false;
  visaExpiryDate: any;
  visaExpiryDt: any = '';
  lastArrivalDt: any;
  visa: any;
  visaURL: any;
  visaImgemptyback:boolean = false;
  defaultMonth: IMyDefaultMonth;
  @ViewChild('errorComp') errorComp : ErrorModalComponent;
  constructor(private router: Router,public _http: AppService, private toastr: ToastrService, private loader: NgxUiLoaderService,private http:EncryptionService){
    this._http.getRefNum().subscribe(data=>{
      this.erefNo = data;
    });
    this._http.getStatus().subscribe(data=>{
      this.mariner = data.Mariner;
      //this.mariner = true;
    });
    let ref = sessionStorage.getItem("AxNo");
    if(ref){
      this.erefNo = ref;
    }
  }
  
  ngOnInit() {
    this._http.scroll();
    const d: Date = new Date();
    this.options = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableUntil: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }
    }
    const today = new Date();
    const disableDate = new Date();
    disableDate.setDate(today.getDate() + 60);
    this.options2 = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableUntil: { 
        year: disableDate.getFullYear(), 
        month: disableDate.getMonth() + 1, 
        day: disableDate.getDate()  
      }
    }
    this.defaultMonth = {
      defMonth: `${disableDate.getMonth() + 1}/${disableDate.getFullYear()}`
    };
    let month:any = this.defaultMonth.defMonth.split('/');
    if (Number(month[0]) < 10) {
      month = '0' + month[0];
    }
    this.defaultMonth.defMonth = `${month}/${disableDate.getFullYear()}`;
    
    this._http.getMasters().subscribe(data=>{
      if(data && data.OccupationList){
          this.docTypeList  = data.DocumentTypeList;
          this._http.getStatus().subscribe(d=>{
           
              this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
                return e.DocumentCategory === 3
              })
            
          })
      }
    });
    this.getVisaInfo();
  }
  overallStatus(){
    let url = 'DIY/DIYOverallStatus';
    this.loader.start();
    let checkSum = this.erefNo;    
    let params = {
      'ReferenceNumber': this.erefNo,
    }
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        if(data && data.IsSuccess){
          let item = data.overallLists;
        }
  
      },
      error: _error=>{
        this.loader.stop();
        this.errorComp.ModalShow(_error.error.Message);
        // this.toastr.error(_error.error.Message)
      }
    })
  }

  getVisaInfo(){
    let checkSum = this.erefNo;
    let url = "DIY/DIYGetVisaInfo";
    let params = {
      "ReferenceNumber": this.erefNo
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        let visaVal = this.http.decryptUsingAES256(data.OutPut)
        this.loader.stop();
        if(visaVal){
          this.mariner = visaVal.Mariner;
          // if(this.mariner){
            if(visaVal.LastIndiaArrival){
            let a = visaVal.LastIndiaArrival.split(' ');
            let d = a[0].split('/'); 
            this.lastArrivalDate = a[0];
            this.lastArrivalDt = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
        // }
          // else{
          //   if(visaVal.Expairy){
          //   let a = visaVal.Expairy.split(' ');
          //   let d = a[0].split('/'); 
          //   this.visaExpiryDate = a[0];
          //   this.visaExpiryDt = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          // }}
        }
      },
      error: error=>{
        this.loader.stop();
        // this.toastr.error(error.error.Message)
        this.errorComp.ModalShow(error.error.Message);
      }
    })
  }

  onDateChanged(event:any){
    this.lastArrivalDate = '';
    this.visaExpiryDate = event.formatted;
    let e = this.visaExpiryDate.split('/')
    let a = e[2]+'-'+e[1]+'-'+e[0];
    let d = new Date();
    let requiredDate= d.setDate(d.getDate() + 15);
    this.sixMonthDate = new Date(requiredDate);
    let selectedDate = new Date(a);
    if(this.sixMonthDate.getTime() > selectedDate.getTime())
    {
      this.expiryDateError = true;
    }else{
      this.expiryDateError = false;
    }
  }

  onDateArrival(event: any) {
    this.visaExpiryDate = '';
    this.lastArrivalDate = event.formatted;
    
    // Convert the selected date to a proper Date object
    let e = this.lastArrivalDate.split('/');
    let formattedDate = `${e[2]}-${e[1]}-${e[0]}`;
    let selectedDate = new Date(formattedDate);

    // Get the current date and calculate the date 60 days ago
    let today = new Date();
    let sixtyDaysAgo = new Date(today.setDate(today.getDate() - 60));

    // Check if the selected date is more than 60 days before today
    if (selectedDate.getTime() < sixtyDaysAgo.getTime()) {
        this.arrivalDateError = true;
    } else {
        this.arrivalDateError = false;
    }
}


  // onDateArrival(event:any){
  //   this.visaExpiryDate = '';
  //   this.lastArrivalDate = event.formatted;
  //   let e = this.lastArrivalDate.split('/')
  //   let a = e[2]+'-'+e[1]+'-'+e[0];
  //   let d = new Date();
  //   let requiredDate= d.setMonth(d.getMonth() - 6);
  //   this.prevsixMonthDate = new Date(requiredDate);
  //   let selectedDate = new Date(a);
  //   if(this.prevsixMonthDate.getTime() > selectedDate.getTime())
  //   {
  //     this.arrivalDateError = true;
  //   }else{
  //     this.arrivalDateError = false;
  //   }
  // }

  typeError(event: boolean){
    this.docError = event;
  }

  getID(id: any){
    this.docType = id;
  }

  backStage(){
    this.router.navigate(['/address'], { replaceUrl: true });
  }

  imageURL(event: any){
    if(event.name === "VISA" && event.url){
      this.pdf1Updt = true;
      this.visaImgempty = false;
    }
    else if(event.name === "VISABACK" && event.url){
      this.pdf2Updt = true;
      this.visaImgemptyback = false;
    }
    if(event.name === "VISA" && !event.url){
      this.pdf1Updt = false;
    }else if(event.name === "VISABACK" && !event.url){
      this.pdf2Updt = false;
    }
  }

  stageValidate(){
    if(!this.pdf1Updt){
      this.visaImgempty = true;
      return;
    }
    // if(!this.pdf2Updt){
    //   this.visaImgemptyback = true;
    //   return;
    // }
    let url = 'DIY/DIYUpdateVisaInfo';
    let checkSum = this.erefNo;
    let params = {
      "ReferenceNumber": this.erefNo,
      "IsIndianPassport":true,
      "LastIndiaArrival":this.lastArrivalDate
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let stageVal = this.http.decryptUsingAES256(data.OutPut)
        if(stageVal && stageVal.IsSuccess){
          // this.toastr.success(stageVal.Success);
          this.router.navigate(['/fatca'], { replaceUrl: true });
        }
        else{
          // this.toastr.error(stageVal.Error);
          this.errorComp.ModalShow(stageVal.Error);
        }
      },error: error=>{
        this.loader.stop();
        if(!window.navigator.onLine){
          // this.toastr.error("It appears that your internet connectivity is slow or please try again.");
          this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
        }else{
          // this.toastr.error(error.error.Message);
          this.errorComp.ModalShow(error.error.Message);
        }
      }
    })

  }

}